<div class="grid gap-4 grid-cols-2 md:grid-cols-3">
  @for (member of list(); track member.id) {
    <div
      class="group px-3 py-5 flex flex-col items-center gap-2 member-card rounded-lg overflow-hidden cursor-pointer transition relative"
      (click)="onMemberClick(member)"
    >
      <div class="size-[4rem] rounded-full relative">
        @if (member.isGanarbol && !member.isDeleted) {
          <div
            data-testid="member-leaf-badge"
            class="size-[1.75rem] bg-[#E6F2F1] flex items-center justify-center rounded-full absolute top-0 left-0 z-1"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="20" viewBox="0 0 14 20" fill="none">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M6.95 2.08044C10.0508 3.80231 11.8303 6.9231 11.8303 10.1754C11.8303 11.8852 11.292 13.2016 10.4558 14.0814C9.62457 14.9559 8.40951 15.4944 6.86058 15.4944C5.29261 15.4944 4.08064 14.9775 3.25898 14.126C2.43416 13.2712 1.89086 11.9625 1.89086 10.1754C1.89086 6.92314 3.67051 3.80234 6.77119 2.08045C6.82688 2.04952 6.89431 2.04952 6.95 2.08044ZM7.54439 1.01005C11.0274 2.94417 13.0547 6.4709 13.0547 10.1754C13.0547 14.1162 10.5556 16.7188 6.86058 16.7188C3.16556 16.7188 0.666504 14.2529 0.666504 10.1754C0.666504 6.47091 2.69391 2.94419 6.17678 1.01006C6.60215 0.773842 7.11901 0.773835 7.54439 1.01005Z"
                fill="#017F70"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M7.69808 19.0514C7.9729 18.8545 8.03604 18.472 7.83911 18.1972C7.48882 17.7084 7.28961 17.0155 7.23939 16.2681C7.18939 15.5241 7.29186 14.7935 7.47913 14.271C7.59321 13.9528 7.42769 13.6023 7.10942 13.4882C6.79115 13.3741 6.44066 13.5396 6.32658 13.8579C6.07498 14.5598 5.95809 15.4617 6.01779 16.3502C6.07726 17.2352 6.31682 18.1748 6.84389 18.9104C7.04083 19.1852 7.42326 19.2483 7.69808 19.0514Z"
                fill="#017F70"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M5.67383 10.5462C5.41458 10.2259 5.25582 9.74342 5.25582 9.14714C5.25582 8.55086 5.41458 8.0684 5.67383 7.74808C5.91956 7.44447 6.29418 7.23613 6.86093 7.23613C7.42767 7.23613 7.80229 7.44447 8.04802 7.74808C8.30727 8.0684 8.46603 8.55086 8.46603 9.14714C8.46603 9.74342 8.30727 10.2259 8.04802 10.5462C7.80229 10.8498 7.42767 11.0581 6.86093 11.0581C6.29418 11.0581 5.91956 10.8498 5.67383 10.5462ZM4.72157 11.3169C5.21506 11.9266 5.94925 12.2832 6.86093 12.2832C7.7726 12.2832 8.5068 11.9266 9.00028 11.3169C9.48024 10.7239 9.69109 9.94457 9.69109 9.14714C9.69109 8.34971 9.48024 7.5704 9.00028 6.97738C8.5068 6.36765 7.7726 6.01107 6.86093 6.01107C5.94925 6.01107 5.21506 6.36765 4.72157 6.97738C4.24161 7.5704 4.03076 8.34971 4.03076 9.14714C4.03076 9.94457 4.24161 10.7239 4.72157 11.3169Z"
                fill="#017F70"
              />
            </svg>
          </div>
        }
        <app-user-avatar
          [size]="64"
          [avatarUrl]="getAvatarUrl(member)"
          [profileColor]="member?.profileColor"
          [initials]="getInitials(member)"
        />
      </div>
      <div class="flex flex-col items-center">
        <div class="text-[1rem]/[160%] font-bold text-[#2C3035] text-center">
          {{ member.isDeleted ? ('common.deletedAccount' | translate: { id: member.id }) : member.fullName }}
        </div>
        <div class="text-[0.8125rem]/[160%] text-[#505760]">
          @if (member.isDirectReferral && member.isGanarbol) {
            {{ 'my-forest.myGanarbol' | translate }}
          } @else if (member.isDirectReferral && member.isGanacuate) {
            {{ 'my-forest.myGanacuate' | translate }}
          } @else {
            {{ member.typeName }}
          }
        </div>
      </div>
      <div
        class="w-full h-[2.6rem] transition-all -bottom-[2.6rem] absolute group-hover:bottom-0 lef-0 bg-[#E6F2F1] p-2 flex gap-4"
      >
        <div class="flex flex-1 justify-center gap-2 items-center">
          <div class="text-[1rem]/[160%] text-[#015A50] font-bold">{{ member?.totalGanarbols }}</div>
          <div class="text-[0.8125rem]/[160%] text-[#015A50]">{{ 'my-forest.ganarbols' | translate }}</div>
        </div>
        <div class="flex flex-1 justify-center gap-2 items-center">
          <div data-testid="member-referrals-count" class="text-[1rem]/[160%] text-[#015A50] font-bold">
            {{ member?.branches ?? 0 }}
          </div>
          <div class="text-[0.8125rem]/[160%] text-[#015A50]">{{ 'my-forest.referrals' | translate }}</div>
        </div>
      </div>
    </div>
  }
</div>
